import {Perspective} from './perspective.model';

export enum SortingStrategyId {
  AlphabeticAsc = 'alphabeticAsc',
  AlphabeticDesc = 'alphabeticDesc',
  FocusMeasureAsc = 'focusMeasureAsc',
  FocusMeasureDesc = 'focusMeasureDesc',
}

export type SortingOptionsType = {
  perspective: Perspective,
  measureCode: string,
  period: string,
  date: Date,
};

export type SortingStrategy<Item> =
  (array: Item[], options: SortingOptionsType) => Item[]
